export default {
  props: {
    labelClasses: {
      type: [String, Array, Object],
      default: 'text-[0.875rem] leading-[1.25rem] text-[#637083] mb-[4px] block',
    },
    helperClasses: {
      type: [String, Array, Object],
      default: 'text-[1rem] text-[#373E49] leading-[1.5rem] mt-[4px] block',
    },
    errorMessageClasses: {
      type: [String, Array, Object],
      default: 'text-[1rem] text-[#B80A0A] leading-[1.5rem] mt-[4px] block',
    },
  },
};
